import type { Feature } from 'ol';
import type { Geometry } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

import { BaseDrawTool } from '#nora-ui/map/drawtools/base-draw-tool';
import { getFeatureStyle } from '#nora-ui/map/drawtools/styles/styles';

export abstract class CreateFeatureBaseDrawTool extends BaseDrawTool {
  override editingVectorSource: VectorSource = new VectorSource();

  protected override editingVectorLayer: VectorLayer<VectorSource>
    = new VectorLayer({
      source: this.editingVectorSource,
    });

  activate(): void {
    // Sometimes the layer already exists, so we remove it first just in case.
    this.drawToolManager.map.getOlMapOrThrow().removeLayer(this.editingVectorLayer);
    this.drawToolManager.map.getOlMapOrThrow().addLayer(this.editingVectorLayer);
  }

  deactivate(): void {
    this.drawToolManager.map.getOlMapOrThrow().removeLayer(this.editingVectorLayer);
  }

  override onStylingUpdated(): void {
    super.onStylingUpdated();
    if (!this.feature) {
      return;
    }

    this.feature?.setProperties(this.getDefaultProperties());
    this.feature?.setStyle(getFeatureStyle);
  }

  loadFeature(feature: Feature<Geometry>): void {
    // Get all drawtool settings from the feature
    // Need to clear the existing feature in the drawtool layers when starting to edit
    // Need to move it away from the current draw layer into the editing layer so the user sees updates.
    // Make sure to continue to store the ID since we need to update instead of create a new feature.
    // If the user cancels it needs to be re-added back to the existing layer as if nothing has happened.
    this.feature = feature;
    this.featureName = (feature.get('name') as string | undefined) ?? '';
    this.featureNameVisible = (feature.get('nameVisible') as boolean | undefined) ?? false;

    this.editingVectorSource.clear();
    this.editingVectorSource.addFeature(feature);
    this.onStylingUpdated();
  }
}
